import $ from 'jquery';
$(document).ready(function () {
    let token = $('meta[name="_token"]').attr('content');

    $(document).on('change', '[data-js-category]', function () {
        let obj = $(this);
        let parentId = obj.find(':selected').val();
        let url = obj.data('url');

        $.ajax({
            url: url,
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: {parentId:parentId},
            dataType: 'JSON',
            type: "POST",
            success: function (response) {
                if (response.success == true) {
                    $('[data-js-subcategory-list]').html(response.subcategoriesView)
                }
            },
            error:function (response) {
            },
            complete:function (data) {
                obj.removeAttr('disabled');
            }
        });

        return false;
    });

    $(document).on('change', '[data-js-subcategory]', function () {
        let obj = $(this);
        let button = obj.closest('form').find('button');

        button.removeAttr('disabled')

        return false;
    });
});
